import { render, staticRenderFns } from "./index-android.vue?vue&type=template&id=9970cd2a&scoped=true&lang=pug&"
import script from "./index-android.vue?vue&type=script&lang=js&"
export * from "./index-android.vue?vue&type=script&lang=js&"
import style0 from "./index-android.vue?vue&type=style&index=0&id=9970cd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9970cd2a",
  null
  
)

export default component.exports